<template>
  <div class="business">
    <div class="business-left">
      <div class="business-left-title">我们的业务</div>
      <div class="business-left-titleEn">Our business</div>
    </div>
    <div class="business-right">
      <div class="business-right-box">
        <div class="left">
          <div class="left-img" @click="tarDetail">
            <img :src="showImg" />
          </div>
          <!-- <div class="left-btn">
          <div
            class="btn-list"
            :style="{
              transform: 'translateX(' + btnTranslateX + 'px)',
            }"
          >
            <div
              :class="{ 'btn-list-active': index === businessNum }"
              class="btn-list-div"
              v-for="(item, index) in businessList"
              :key="index"
              @click="changeBusiness(index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div
            class="btn-line"
            :style="{
              transform: 'translateX(' + btnTranslateX + 'px)',
            }"
          >
            <div
              class="btn-line-div"
              :style="{
                transform: 'translateX(' + businessTranslateX + 'px)',
              }"
            ></div>
          </div>
        </div> -->
        </div>
        <div class="info">
          <div class="info-title">{{ businessList[businessNum].title }}</div>
          <div class="info-title2">{{ businessList[businessNum].title2 }}</div>
          <div class="info-content">
            {{ businessList[businessNum].content }}
          </div>
          <!-- <div class="info-btn">
          <img :src="iconLeft" @click="businessNumChange('per')" />
          <img :src="iconRight" @click="businessNumChange('next')" />
        </div> -->
        </div>
      </div>
      <div class="business-right-bottom">
        <img :src="iconLeft" @click="businessNumChange('per')" />
        <div class="left-btn">
          <div
            class="btn-list"
            :style="{
              transform: 'translateX(' + btnTranslateX + 'px)',
            }"
          >
            <div
              :class="{ 'btn-list-active': index === businessNum }"
              class="btn-list-div"
              v-for="(item, index) in businessList"
              :key="index"
              @click="changeBusiness(index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div
            class="btn-line"
            :style="{
              transform: 'translateX(' + btnTranslateX + 'px)',
            }"
          >
            <div
              class="btn-line-div"
              :style="{
                transform: 'translateX(' + businessTranslateX + 'px)',
              }"
            ></div>
          </div>
        </div>
        <img :src="iconRight" @click="businessNumChange('next')" />
      </div>
    </div>
  </div>
</template>

<script>
import business from "@/assets/img/img_business.png";
import business2 from "@/assets/img/img_business2.png";
import business3 from "@/assets/img/img_business3.png";
import business4 from "@/assets/img/img_business4.png";
import business5 from "@/assets/img/img_business5.png";
import business6 from "@/assets/img/img_business6.png";
import business7 from "@/assets/img/img_business7.png";
import business8 from "@/assets/img/img_business8.png";
import business9 from "@/assets/img/img_business9.png";
import business10 from "@/assets/img/img_business10.png";
import business11 from "@/assets/img/img_business11.png";
import business12 from "@/assets/img/img_business12.png";
import iconRight from "@/assets/img/icon_right.png";
import iconLeft from "@/assets/img/icon_left.png";
export default {
  name: "homeBusiness",
  data() {
    return {
      business,
      business2,
      business3,
      business4,
      business5,
      business6,
      business7,
      business8,
      business9,
      business10,
      business11,
      business12,
      iconRight,
      iconLeft,
      businessList: [
        {
          type: "1",
          num: "0",
          title: "病案统计管理系统",
          img: business,
          title2: "产品介绍",
          content:
            "普康病案统计管理系统是医院信息系统建设中的重要组成部分，是集病案收集、整理、存储、查询、统计等功能于一体的医疗信息系统，涵盖了医院门诊日志、病人病案首页、医院统计报表等大量信息，不仅能反映出医院经营管理的现状和水平，也能为医院的经营管理决策提供科学可靠的依据。",
        },
        {
          type: "1",
          num: "1",
          title: "病案示踪管理系统",
          img: business2,
          title2: "产品介绍",
          content:
            "普康病案示踪管理系统详细记载病案从回收至入库的每一环节，提供了对病案的签出、签收、内部流转、上架、入库、借阅、复印、归还等环节的管理措施，从而管理纸质病案的实时流通状态，帮助医院实现了病案流向管理的规范化、系统化.数字化。",
        },
        {
          type: "2",
          num: "0",
          title: "病案首页全流程质控系统",
          img: business3,
          title2: "产品介绍",
          content:
            "病案首页作为患者诊疗过程的精要，不仅是医疗信息的基础来源，更是医院医疗水平与质量的重要体现。加强病案质控，不仅能显著提升医疗服务的品质，还是预防医疗纠纷的关键措施。普康病案首页质控系统致力于从多个维度，包括完整性、合理性和规范性等，对病案首页的填写质量进行持续的优化和改进。通过这种方式，系统有效降低了病案的缺陷率，推动了病案管理的标准化、体系化和规范化，实现了全面的闭环管理。",
        },
        {
          type: "2",
          num: "1",
          title: "AI电子病历质控系统",
          img: business4,
          title2: "产品介绍",
          content:
            "普康AI电子病历质控系统是一款利用人工智能技术对电子病历进行质量控制的系统。基于知识图谱与强大的自然语言处理等技术，对电子病历的完整性、准确性、规范性等进行全面检测和评估，以提高病历质量，为医疗安全提供有力保障。",
        },
        {
          type: "2",
          num: "2",
          title: "医保结算清单质控系统",
          img: business5,
          title2: "产品介绍",
          content:
            "普康医保结算清单质控系统是一款高效的管理系统，专注于提高医保结算清单的质量和准确性。该系统凭借其内置丰富的质控规则库，连通了从数据采集、清单编制、质量监控、审核到上报的所有服务模块，全面覆盖了院内的医保结算清单管理流程。不仅为医院提供了全面的管理工具，还为医保清单提供了严密的监控机制。",
        },
        {
          type: "3",
          num: "0",
          title: "DRG运营监管系统",
          img: business6,
          title2: "产品介绍",
          content:
            "普康DRG运营监管系统是一款实时监控系统，致力于医保在院运行管理。通过全程监控患者入院至出院的费用和入组情况该系统可确保医保资金有效使用和患者的合理权益。与HIS或电子病历系统集成，为医院提供全面的数据支持和决策依据。",
        },
        {
          type: "3",
          num: "1",
          title: "DIP管理系统",
          img: business7,
          title2: "产品介绍",
          content:
            "普康DIP运营监管系统致力于精准把控医疗成本，优化病种结构。通过全面的在院运行监管、医保费用盈亏分析及异常费用预警，助力医院提升医疗能力，实现预期医保支付效果。",
        },
        {
          type: "4",
          num: "0",
          title: "单病种质控管理系统",
          img: business8,
          title2: "产品介绍",
          content:
            "普康单病种质量管理系统致力于对单病种进行集中管理、质量控制和数据上报。通过自动化的数据采集和统计分析，该系统能够确保医院单病种质量控制指标的准确性和可靠性，从而为医院提供有力的数据支撑，助力医院提升单病种质量管理水平。",
        },
        {
          type: "4",
          num: "1",
          title: "核心指标分析系统",
          img: business9,
          title2: "产品介绍",
          content:
            "普康核心指标分析系统是一款涵盖指标定义、指标建模、指标固化、指标可视化分析，实现指标全流程、一体化管理的软件产品，可灵活配置可视化指标反馈图表，支持报表、看板、刊报等多个生成展示方式，采用全拖拽式的配置方法，步骤简单、界面清晰，医院人员轻松驾驭。",
        },
        {
          type: "4",
          num: "2",
          title: "公立医院绩效管理系统",
          img: business10,
          title2: "产品介绍",
          content:
            "普康公立医院绩效管理系统，依据国家卫生健康委公立医院绩效考核上报数据要求，致力于实现上报数据的自动采集与上报，从而显著减少手工工作量，提升工作效率。该系统不仅仅局限于数据采集和上报，更针对绩效考核的各项指标标准进行深入的多维分析。通过先进的数据分析技术，该系统能够帮助医院提升运营和质量管理能力，为其可持续发展提供有力支持。",
        },
        {
          type: "4",
          num: "3",
          title: "医院等级评审",
          img: business11,
          title2: "产品介绍",
          content:
            " 普康医院等级评审系统专注于从医院的功能与任务、规模与运营管理，以及医疗质量与技术水平三大维度出发，为医院等级评审提供全面的支持。该系统能够实现快速的数据采集、整理、分析、存储及管理，确保数据的准确性和完整性。通过灵活的配置，系统能够生成各种可视化指标反馈图表，帮助评审专家直观地了解医院运营状况。",
        },
        {
          type: "5",
          num: "0",
          title: "配置化数据上报集成系统",
          img: business12,
          title2: "产品介绍",
          content:
            "普康配置化数据上报集成系统是一种高效、灵活、可扩展的数据集成上报解决方案，将上报平台集成到一起统一管理，采用配置化的方式快速地将不同来源的数据进行整合、清洗、转换和上报。",
        },
      ],
      businessNum: 0,
      businessTranslateX: null,
      btnTranslateX: 0,
      showImg: null,
    };
  },
  methods: {
    changeBusiness(i) {
      this.setBusinessLine(i);
    },
    setBusinessLine(index) {
      this.showImg = this.businessList[index].img;
      const elements = document.querySelectorAll(".btn-list-div");
      // 获取边距
      const computedStyle = window.getComputedStyle(elements[0]);
      const marginDiv = computedStyle.marginRight.replace("px", "");
      // 修改下划线宽度
      document.querySelector(".btn-line-div").style.width =
        elements[index].offsetWidth + "px";
      // console.log(document.querySelector(".nav-line-div").style.width);
      // this.businessLineWidth = elements[index].offsetWidth + "px";
      let numX = 0;
      elements.forEach((item, i) => {
        if (index > i) {
          numX = numX + item.offsetWidth;
        }
      });
      if (index != 0 && index != 11) {
        if (index > this.businessNum && index != 1) {
          this.btnTranslateX =
            -(numX + marginDiv * ((index - 1) * 2)) +
            elements[index - 1].offsetWidth;
        } else if (index < this.businessNum && index != 10) {
          this.btnTranslateX =
            -(numX + marginDiv * ((index - 1) * 2)) +
            elements[index - 1].offsetWidth;
        }
      }
      // console.log(numX, this.btnTranslateX);
      this.businessNum = index;
      this.businessTranslateX = numX + marginDiv * (index * 2 + 1);
      // console.log(this.businessTranslateX);
    },
    businessNumChange(val) {
      let num = this.businessNum;
      if (val == "per") {
        if (num == 0) {
          return;
          num = this.businessList.length - 1;
        } else {
          num--;
        }
      } else {
        if (num == this.businessList.length - 1) {
          return;
          num = 0;
        } else {
          num++;
        }
      }
      this.changeBusiness(num);
    },
    tarDetail() {
      this.$router.push({
        path: "/productDetail",
        query: {
          type: this.businessList[this.businessNum].type,
          num: this.businessList[this.businessNum].num,
        },
      });
    },
    handleResize() {
      // console.log(this.actNum);
      if (document.documentElement.clientWidth < 1280) {
        return;
      } else {
        this.setBusinessLine(this.businessNum);
      }
    },
  },
  mounted() {
    this.changeBusiness(0);
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.business {
  display: flex;
  justify-content: space-between;
  background-color: #fdfdfd;
  padding: 172px 360px 155px 260px;
  &-left {
    &-title {
      font-size: 24px;
      // font-weight: bold;
    }
    &-titleEn {
      margin-top: 10px;
      font-size: 24px;
      // font-weight: bold;
      color: #999;
    }
  }
  &-right {
    width: 954px;
    &-box {
      display: flex;
      .left {
        width: 542px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-img {
          overflow: hidden;
          width: 542px;
          height: 400px;
          background-color: #fff;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.25s ease-in;
          }
          img:hover {
            transform: scale(1.05, 1.05);
            transition: all 0.25s ease-in;
          }
        }
      }
      .info {
        position: relative;
        width: 412px;
        height: 400px;
        background-color: #004f6a;
        padding: 50px 78px 0 68px;
        box-sizing: border-box;
        color: #fff;
        &-title {
          font-size: 20px;
          font-weight: bold;
        }
        &-title2 {
          font-size: 16px;
          margin-top: 10px;
        }
        &-content {
          margin-top: 26px;
          border-top: 1px solid #d9d9d9;
          padding-top: 16px;
          font-size: 15px;
          line-height: 28px;
          height: 196px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 7;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        &-btn {
          margin-top: 42px;
          display: flex;
          justify-content: space-between;
          padding: 0 40px 0 50px;
          img {
            cursor: pointer;
          }
        }
      }
      .info::before {
        content: "";
        position: absolute;
        top: 90px;
        left: -20px; /* 调整三角形的位置 */
        width: 0;
        height: 0;
        border-top: 27px solid transparent; /* 三角形的上边 */
        border-bottom: 27px solid transparent; /* 三角形的下边 */
        border-right: 54px solid #004f6a; /* 三角形的右边，可以根据需要调整颜色和宽度 */
      }
    }
    &-bottom {
      background-color: #f5f6fb;
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 80px;
      align-items: center;
      padding: 0 26px;
      box-sizing: border-box;
      img {
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
      .left-btn {
        margin: 0 16px;
        width: calc(100% - 40px);
        overflow: hidden;
        position: relative;
        .btn-list {
          height: 100%;
          display: flex;
          align-items: center;
          // overflow: hidden;
          &-div {
            margin: 0 16px;
            // line-height: 32px;
            cursor: pointer;
            font-size: 16px;
            line-height: 78px;
            border-bottom: 2px solid #f5f6fb;
            white-space: nowrap;
          }
          &-div:hover {
            border-bottom: 2px solid #004f6a;
          }
          &-active {
            color: #004f6a;
          }
          &-active:hover {
            border-bottom: 2px solid transparent;
          }
        }
        .btn-line {
          margin: 0 auto;
          margin-top: -2px;
          height: 2px;
          background: transparent;
          &-div {
            width: 180.6px;
            // height: 1px;
            border-bottom: 2px solid #004f6a;
            transition-duration: 0.3s;
            // background: #004f6a;
          }
        }
      }
    }
  }
}
</style>